import { useTranslation } from "react-i18next";
import Form from "react-bootstrap/Form";

interface FilterTextInputProps {
  propertyName: string;
  label: string;
  placeholder: string;
  value: string;
  onChange: Function;
}

export default function FilterTextInput(props: FilterTextInputProps) {
  const { t } = useTranslation();

  return (
    <Form.Group className="pb-3">
      <Form.Label className="font-weight-600" htmlFor={props.propertyName}>
        {t(props.label)}
      </Form.Label>
      <Form.Control
        className="py-075-rem bg-white"
        type="text"
        id={props.propertyName}
        name={props.propertyName}
        placeholder={t(props.placeholder)}
        value={props.value}
        onChange={(value) => {
          props.onChange(value);
        }}
      />
    </Form.Group>
  );
}
